import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 4,
    overflowY: 'scroll',
  },
  h2:
  {
    color: 'black',
  },
  modalContent:
  {
    maxWidth: '700px',
    maxHeight: '90%',
    height: '100%',
  }
}));

export default function TransitionModal(props)
{
  const classes = useStyles();
  return (
    <div className='modal'>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={props.isOpen}
        onClose={() => props.onClose()}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.isOpen}>
          <div
            className={`${classes.modalContent} ${classes.paper}`}
            style={props.width ? {width: props.width, maxWidth: props.width} : {}}
          >
            <h2 className={classes.h2}>{props.title}</h2>
            <p className={classes.h2} id="transition-modal-description">{props.description}</p>
            {props.modalContent}
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
